import { BUSCAR_CTES_DISPONIVEIS_MDFE } from '../../actions/types'

export default function reducerBuscarCtesDisponiveisMdfe(state = [], action = undefined) {
  switch (action.type) {
    case BUSCAR_CTES_DISPONIVEIS_MDFE: {
      const ctes = action.payload.data;
      if (ctes) {
        return ctes
      }
      return []
    }
    default: {
      return state
    }
  }
}
